import { useState, useEffect } from 'react'
import { useClient, usePaginatedFetch } from '../../hooks'

const checkParams = (query, title, skill, tag, head_count, sort) => {
  let params = ''
  if (query) {
    params += `name=${query}`
  }
  if (title) {
    params += `&job_title=${title}`
  }
  if (skill?.length >= 1) {
    params += `&skills=${skill}`
  }
  if (tag?.length >= 1) {
    params += `&tags=${tag}`
  }
  if (head_count) {
    params += `&headCount=${head_count}`
  }
  if (sort) {
    params += `&orderBy=name`
  }
  return params
}

const useGetClients = () => {
  const {
    searchValue,
    searchTitle,
    searchSkill,
    searchTag,
    searchHeadCount,
    alphaSort,
  } = useClient()
  const base = 'v1/clients/search'
  let urlParam =
    searchValue ||
    searchTitle ||
    searchTag ||
    searchSkill ||
    searchHeadCount ||
    alphaSort
      ? base +
        `?${checkParams(
          searchValue,
          searchTitle,
          searchSkill,
          searchTag,
          searchHeadCount,
          alphaSort,
        )}`
      : base
  const [url, setUrl] = useState(urlParam)
  const [clients, setClients] = useState()
  let { data, ...rest } = usePaginatedFetch(url, 'Unable to fetch client data')

  const search = () => {
    setUrl(
      searchValue ||
        searchTitle ||
        searchTag ||
        searchSkill ||
        searchHeadCount ||
        alphaSort
        ? base +
            `?${checkParams(
              searchValue,
              searchTitle,
              searchSkill,
              searchTag,
              searchHeadCount,
              alphaSort,
            )}`
        : base,
    )
  }

  const eshotSearch = query => {
    setUrl(base + `?name=${query}`)
  }

  const addClient = client => {
    setClients(cur => [client, ...cur])
  }

  useEffect(() => {
    setClients(data)
  }, [data])

  const formattedData =
    clients &&
    clients.map(client => ({
      status: client.status,
      id: client.id,
      name: client.name,
      contact_email: client.contact_email,
      contact_telephone: client.contact_telephone,
    }))

  return { ...rest, data: formattedData, search, addClient, eshotSearch }
}

export default useGetClients
